<template>
  <PButton
    rounded
    :class="[DATATABLE_TOOLBAR_ICON_BUTTON_SIZE_CLASS, 'shrink-0 bg-white! p-0']"
    severity="secondary"
    variant="outlined"
    @click="(event) => togglePopover(event)"
    data-test="button-settings"
  >
    <template #icon>
      <FontAwesomeIcon
        v-if="!loading"
        :icon="['far', 'ellipsis']"
        size="lg"
      />
      <FontAwesomeIcon
        v-else
        :icon="['far', 'spinner']"
        size="lg"
        spin
      />
    </template>
  </PButton>

  <Popover
    ref="popover"
    :pt="{ content: '!p-0 !m-0' }"
  >
    <div
      class="flex flex-col gap-1 py-1"
      @click="closePopover"
    >
      <slot />
    </div>
  </Popover>
</template>

<script setup>
import { ref } from 'vue';
import { DATATABLE_TOOLBAR_ICON_BUTTON_SIZE_CLASS } from '@/app/data/datatable_constants';

const props = defineProps({
  loading: { type: Boolean, default: false },
});

const popover = ref(null);

const togglePopover = (event) => {
  popover.value.toggle(event);
};

const closePopover = () => {
  popover?.value?.toggle(false);
};
</script>
